import { render, staticRenderFns } from "./DetailsContacts.vue?vue&type=template&id=d1de7270&scoped=true&"
import script from "./DetailsContacts.vue?vue&type=script&lang=js&"
export * from "./DetailsContacts.vue?vue&type=script&lang=js&"
import style0 from "./DetailsContacts.vue?vue&type=style&index=0&id=d1de7270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1de7270",
  null
  
)

export default component.exports